var React = require('react');

function Man2 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#ffdb00","fillRule":"evenodd","d":"M32 7.45a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0zm-1 0a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z","clipRule":"evenodd","key":0}),React.createElement("path",{"fill":"#ffdb00","d":"M14.5 28c0-6 4.93-11 11-11s11 5 11 11h1c0-6.55-5.37-12-12-12s-12 5.45-12 12h1z","key":1}),React.createElement("path",{"fill":"#ffdb00","fillRule":"evenodd","d":"M9 13a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm0-1a3 3 0 1 0 0-6 3 3 0 0 0 0 6z","clipRule":"evenodd","key":2}),React.createElement("path",{"fill":"#ffdb00","d":"M1 24a8.03 8.03 0 0 1 12.24-6.72l.52-.85A9.02 9.02 0 0 0 0 24h1z","key":3})]);
}

Man2.defaultProps = {"fill":"none","viewBox":"0 0 38 28"};

module.exports = Man2;

Man2.default = Man2;
